import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable()
export class StatsSharedService {
    private isSingleStatModeSubject = new BehaviorSubject<boolean>(false);
    readonly isSingleStatMode$ = this.isSingleStatModeSubject.asObservable();

    private exportRequestedSubject = new Subject<void>();
    readonly exportRequested$ = this.exportRequestedSubject.asObservable();

    setIsSingleStatMode(isSingleStatMode: boolean): void {
        this.isSingleStatModeSubject.next(isSingleStatMode);
    }

    requestExport(): void {
        this.exportRequestedSubject.next();
    }
}
